import { CurrentReservationService } from '@/common/services/reservation/current';
import { fromISOtoDate } from '@/common/utils/date/fromISOtoDate.util';
import {
    getScheduleHours,
    resolveAutoHour,
    resolveReturnBranchId,
    validateScheduleHourAvailability,
} from '@/common/utils/reservation/schedule.utils';
import { FindLocationsUseCase } from '@/core/domain/locations/usecases/findLocations.usecase';
import { selectDifferentLocations } from '@/core/reservation/store/differentLocations.selector';
import { selectEndHours } from '@/core/reservation/store/end-hours.selector';
import { selectLocations } from '@/core/reservation/store/locations.selector';
import { selectStartHours } from '@/core/reservation/store/start-hours.selector';
import { NgbDate } from '@ng-bootstrap/ng-bootstrap';
import {
    Component,
    ElementRef,
    HostBinding,
    HostListener,
    Inject,
    Input,
    OnInit,
    ViewChild,
    ViewEncapsulation,
} from '@angular/core';
import { Store } from '@ngrx/store';
import _ from 'lodash';
import { Observable, catchError, of, switchMap, throwError } from 'rxjs';
import { InputComponent } from '../../ui/input/input.component';
import { DateTime } from 'luxon';
import { saveStartHours } from '@/core/reservation/store/start-hours.actions';
import { saveEndHours } from '@/core/reservation/store/end-hours.actions';
import { RestoreReservationUseCase } from '@/core/domain/reservation/usecases/restoreReservation.usecase';
import { fromJSDateToInputDate } from '@/common/utils/date/fromJSDateToInputDate';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { UpdateReservationUseCase } from '@/core/domain/reservation/usecases/updateReservation.usecase';
import { ValidationService } from '@/common/services/validation/validation.service';
import { saveLocations } from '@/core/reservation/store/locations.actions';
import { saveDifferentLocations } from '@/core/reservation/store/differentLocations.actions';
import { selectReservation } from '@/core/reservation/store/reservation.selector';
import { fromJSDateToISODate } from '@/common/utils/date/fromJSDateToISODate';
import { FindSchedulesUseCase } from '@/core/domain/locations/usecases/findSchedules.usecase';
import { AlertService } from '@/common/services/alert/alert.service';
import { FindBranchesUseCase } from '@/core/domain/branches/usecases/findBranches.usecase';
import { BranchParams } from '@/core/domain/branches/models/branch.model';
import { saveVehicles } from '@/core/reservation/store/vehicles.actions';
import { Router } from '@angular/router';
import { Location } from '@/core/domain/locations/models/location.model';
import { isValid } from '@/common/utils/validation/common.utils';
import { UrlService } from '@/common/services/url/url.service';
import { BranchIntParams } from '@/core/domain/branches-international/models/branch-international.model';
import { saveLocationInt } from '@/core/international/store/international.actions';
import { GetAvailabilityInternationalUseCase } from '@/core/domain/branches-international/usecases/getAvailabilityInternational.usecase';

@Component({
    selector: 'fe-progress-bar',
    templateUrl: './progress-bar.component.html',
    styleUrls: ['./progress-bar.component.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class ProgressBarComponent implements OnInit {
    public datetimeOpened = false;

    public datetimeSelected = true;

    public locationOpened = false;

    public locactionSelected = true;
    wasDisabled = false;

    public startDate: Date = new Date();

    public endDate: Date = new Date();

    @ViewChild('location') inputLocation!: InputComponent;

    @ViewChild('differentLocationProgressBar')
    inputDifferentLocationProgressBar!: InputComponent;

    @ViewChild('inputStartDate') inputStartDate!: InputComponent;
    @ViewChild('inputEndDate') inputEndDate!: InputComponent;
    @ViewChild('inputStartHour') inputStartHour!: InputComponent;
    @ViewChild('inputEndHour') inputEndHour!: InputComponent;

    @Input() status: 'datetime' | 'location' | 'vehicle' | 'extras' | 'total' =
        'total';

    public formDatetime!: FormGroup;
    public formLocations!: FormGroup;

    public loadingStartHours = false;
    public loadingEndHours = false;

    public loadingUpdate = false;

    public loadingLocations = false;

    public loadingDifferentLocations = false;

    public fromDate: NgbDate | null = null;
    public toDate: NgbDate | null = null;
    public hoveredDate: NgbDate | null = null;
    public isSelecting = false;

    public currency?: string;

    @HostBinding('class.progress-bar-stick') progressBarStick = false;

    @Input() containerToSitck = '';

    public martinTopContainer = 0;

    @Input() disabled = false;

    @Input() defaultLocation: string | null = null;

    constructor(
        private readonly elementRef: ElementRef,
        private readonly store: Store,
        @Inject('DATE_FORMAT_PROGRESS_BAR')
        public dateFormatProgressBar: string,
        @Inject('DATE_FORMAT_PROGRESS_BAR_SHORT')
        public dateFormatProgressBarShort: string,
        public reservation: CurrentReservationService,
        private readonly findLocationsUseCase: FindLocationsUseCase,
        private readonly url: UrlService,
        @Inject('INPUT_DATEPICKER') public inputDatePickerFormat: string,
        private restoreReservationUseCase: RestoreReservationUseCase,
        private updateReservationUseCase: UpdateReservationUseCase,
        private readonly formBuilder: FormBuilder,
        private readonly validation: ValidationService,
        private readonly alert: AlertService,
        private readonly router: Router,
        private readonly findSchedulesUseCase: FindSchedulesUseCase,
        private readonly findbranchesUseCase: FindBranchesUseCase,
        private readonly getAvailabilityInternational: GetAvailabilityInternationalUseCase,
    ) {
        this.initFormDatetime();
        this.initFormLocations();
    }

    get showTotalCents(): boolean {
        return (
            this.status === 'total' ||
            this.reservation.current?.origin === 'INT'
        );
    }

    get totalDigitsInfo(): string {
        return this.showTotalCents ? '1.2-2' : '1.0-0';
    }

    get isWithoutProtection(): boolean {
        return (
            this.status === 'total' &&
            this.reservation.current?.origin !== 'INT' &&
            !this.reservation.insurances?.length
        );
    }

    get displayTotal(): number | undefined {
        const total = Number(this.reservation.total);
        if (!Number.isFinite(total)) {
            return undefined;
        }
        return this.showTotalCents ? total : Math.ceil(total);
    }

    @HostListener('document:click', ['$event.target'])
    public onClick(targetElement: any) {
        if (!this.datetimeOpened && !this.locationOpened) {
            return;
        }
        if (
            this.elementRef.nativeElement.contains(targetElement) ||
            targetElement.classList.contains('ng-option') ||
            targetElement.classList.contains('container-col-name') ||
            targetElement.classList.contains('btn-locations-select') ||
            targetElement.closest('.btns-after') !== null ||
            targetElement.classList.contains('ng-option-label') ||
            targetElement.classList.contains('btn-alert-confirm') ||
            targetElement.classList.contains('btn-alert-cancel') ||
            targetElement.classList.contains('cancel__subtitle') ||
            targetElement.classList.contains('cancel__title') ||
            targetElement.classList.contains('swal2-container') ||
            targetElement.classList.contains('swal2-popup') ||
            targetElement.classList.contains('swal2-close') ||
            targetElement.classList.contains('ng-value-icon') ||
            targetElement.classList.contains('custom-day') ||
            targetElement.classList.contains('ngb-dp-day') ||
            targetElement.classList.contains('ngb-dp-week-number') ||
            targetElement.classList.contains('ngb-dp-weekday') ||
            targetElement.classList.contains('ngb-dp-header') ||
            targetElement.classList.contains('ngb-dp-month') ||
            targetElement.classList.contains('ngb-dp-navigation-chevron') ||
            targetElement.classList.contains('ngb-dp-arrow') ||
            targetElement.classList.contains('ngb-dp-navigation-select') ||
            targetElement.closest('.ngb-dp-content') !== null ||
            targetElement.closest('.ngb-dp-header') !== null ||
            targetElement.closest('ngb-datepicker') !== null ||
            targetElement.closest('ng-dropdown-panel') !== null ||
            targetElement.closest('ng-select') !== null ||
            targetElement.closest('.swal2-container') !== null ||
            targetElement.closest('ngb-tooltip-window') !== null
        ) {
            return;
        }

        this.close(true);
    }

    @HostListener('document:scroll')
    public onScroll() {
        const scrollTop =
            window.pageYOffset ||
            document.documentElement.scrollTop ||
            document.body.scrollTop ||
            0;
        const header = document.querySelector('.header-main');
        if (!isValid(header)) {
            return;
        }
        const headerHeight = header?.clientHeight;
        this.progressBarStick = scrollTop > (headerHeight as number);
        const progressBar = document.querySelector('fe-progress-bar');
        if (!isValid(progressBar)) {
            return;
        }
        this.martinTopContainer =
            scrollTop > (headerHeight as number)
                ? (progressBar?.clientHeight as number)
                : 0;
    }

    protected close(initReservation = false): void {
        this.datetimeOpened = false;
        this.locationOpened = false;
        if (initReservation) {
            this.store
                .select(selectLocations)
                .pipe(
                    switchMap((locations) => {
                        this.reservation.locations = locations;
                        return of(locations);
                    }),
                )
                .subscribe();
            this.initReservation();
        }
    }

    public ngOnInit(): void {
        this.initReservation();
        this.store
            .select(selectStartHours)
            .pipe(
                switchMap((hours) => {
                    this.reservation.startHours = hours;
                    return of(hours);
                }),
            )
            .subscribe();
        this.store
            .select(selectEndHours)
            .pipe(
                switchMap((hours) => {
                    this.reservation.endHours = hours;
                    return of(hours);
                }),
            )
            .subscribe();
        this.store
            .select(selectLocations)
            .pipe(
                switchMap((locations) => {
                    this.reservation.locations = locations;
                    return of(locations);
                }),
            )
            .subscribe();
        this.store
            .select(selectDifferentLocations)
            .pipe(
                switchMap((locations) => {
                    this.reservation.differentLocations = locations;
                    return of(locations);
                }),
            )
            .subscribe();
        this.store
            .select(selectReservation)
            .pipe(
                switchMap((reservation) => {
                    this.reservation.total = reservation.total;
                    this.currency = reservation.currency;
                    return of(reservation);
                }),
            )
            .subscribe();
    }

    private initFormDatetime(): void {
        this.formDatetime = this.formBuilder.group(
            {
                startDate: ['', Validators.compose([Validators.required])],
                startHour: ['', Validators.compose([Validators.required])],
                endDate: ['', Validators.compose([Validators.required])],
                endHour: ['', Validators.compose([Validators.required])],
            },
            {
                validators: [
                    this.validation.maxDifferenceDates(
                        'startDate',
                        'endDate',
                        31,
                    ),
                    this.validation.isGreaterThanDatetime(
                        'startDate',
                        'startHour',
                        'endDate',
                        'endHour',
                    ),
                ],
            },
        );
    }

    private initFormLocations(): void {
        this.formLocations = this.formBuilder.group(
            {
                location: ['', Validators.compose([Validators.required])],
                differentLocation: [
                    '',
                    Validators.compose([Validators.required]),
                ],
            },
            {
                validator: this.validation.mismatchingControls(
                    'location',
                    'differentLocation',
                ),
            },
        );
        this.formLocations
            .get('location')
            ?.valueChanges.subscribe((response) =>
                this.onGetLocationName(response),
            );
        this.formLocations
            .get('differentLocation')
            ?.valueChanges.subscribe((response) =>
                this.onGetDifferenteLocationName(response),
            );
    }

    private onGetLocationName(locationSelected: string[]): void {}
    private onGetDifferenteLocationName(locationSelected: string[]): void {}

    private initReservation(): void {
        this.restoreReservationUseCase
            .execute()
            .pipe(
                switchMap((reservation) => {
                    this.checkLocation(reservation);
                    this.startDate = fromISOtoDate(reservation.startDate);
                    this.endDate = fromISOtoDate(reservation.endDate);
                    if (this.startDate) {
                        this.fromDate = new NgbDate(
                            this.startDate.getFullYear(),
                            this.startDate.getMonth() + 1,
                            this.startDate.getDate(),
                        );
                    }
                    if (this.endDate) {
                        this.toDate = new NgbDate(
                            this.endDate.getFullYear(),
                            this.endDate.getMonth() + 1,
                            this.endDate.getDate(),
                        );
                    }
                    if (
                        isValid(this.reservation.current.startDate) &&
                        isValid(this.reservation.current.endDate)
                    ) {
                        this.findHours();
                    }
                    this.forceUpdateDatepicker();
                    return of(reservation);
                }),
            )
            .subscribe();
    }

    private checkLocation(reservation: any): void {}

    //FIX: buscar una mejor manera
    private forceUpdateDatepicker(): void {
        setTimeout(() => {
            this.startDate = DateTime.fromJSDate(this.startDate)
                .plus({
                    seconds: 1,
                })
                .toJSDate();
            this.endDate = DateTime.fromJSDate(this.endDate)
                .plus({
                    seconds: 1,
                })
                .toJSDate();
        }, 1000);
    }

    protected checkeLocationDates(): void {
        setTimeout(() => {
            if (
                isValid(this.reservation.current.location) &&
                isValid(this.reservation.current.startDate) &&
                !this.formDatetime.hasError('differenceDatesOut') &&
                !this.formDatetime.hasError('lessThanDate')
            ) {
                this.findHours();
            } else {
                //TODO
            }
        });
    }

    private resetHoursLocal(): void {
        this.reservation.current.startHour = null;
        this.reservation.current.endHour = null;
        this.reservation.startHours = [];
        this.reservation.endHours = [];
    }

    protected findHours(): void {
        this.loadingStartHours = true;
        const branch = _.find(
            this.reservation.locations,
            (item) => item.id === _.first(this.reservation.current.location),
        );
        const typeReservation = branch.location == 'INT' ? 'INT' : 'NAT';
        this.findSchedulesUseCase
            .execute({
                id: _.first(this.reservation.current.location) as string,
                location: typeReservation,
                pickup: [
                    fromJSDateToISODate(this.startDate as Date),
                    'T',
                    DateTime.now().toFormat('HH:mm:ss'),
                ].join(''),
                return: [
                    fromJSDateToISODate(this.endDate as Date),
                    'T',
                    DateTime.now().toFormat('HH:mm:ss'),
                ].join(''),
            })
            .pipe(
                catchError((error) => {
                    this.loadingStartHours = false;
                    this.resetHoursLocal();
                    this.alert
                        .open({
                            title: this.alert.getErrorTitle(error),
                            subtitle: this.alert.getErrorMessage(error),
                            showCancel: false,
                        })
                        .subscribe();
                    return throwError(() => error);
                }),
                switchMap((schedulesResponse) => {
                    this.onGetSchedules(schedulesResponse);
                    return of(schedulesResponse);
                }),
            )
            .subscribe();
    }

    private autoSelectStartHour(): void {
        if (!this.startDate) return;
        const match = resolveAutoHour(
            this.reservation.startHours,
            this.startDate,
            this.reservation.current.startHour,
        );
        if (match) {
            this.reservation.current.startHour = match;
            this.formDatetime.get('startHour')?.setValue(match);
        }
    }

    private autoSelectEndHour(): void {
        if (!this.endDate) return;
        const match = resolveAutoHour(
            this.reservation.endHours,
            this.endDate,
            this.reservation.current.endHour,
        );
        if (match) {
            this.reservation.current.endHour = match;
            this.formDatetime.get('endHour')?.setValue(match);
        }
    }

    private onGetSchedules(hours: any): void {
        this.loadingStartHours = false;
        this.reservation.startHours = _.get(hours, 'data.schedules.pickup', []);
        this.reservation.current.discountCode = _.get(
            hours,
            'data.coupons.0',
            '',
        );
        this.reservation.endHours = _.get(hours, 'data.schedules.return', []);
        this.autoSelectStartHour();

        setTimeout(() => {
            if (this.reservation.startHours.length > 0 && !this.reservation.current.startHour) {
                this.inputStartHour.focus();
            }
        }, 100);
    }

    public onFromDateChange(date: NgbDate | null): void {
        this.fromDate = date;
        if (date) {
            this.startDate = new Date(date.year, date.month - 1, date.day);
            this.reservation.current.startDate = fromJSDateToInputDate(
                this.startDate,
            );

            if (this.endDate && this.endDate <= this.startDate) {
                const newEndDate = new Date(this.startDate);
                newEndDate.setDate(newEndDate.getDate() + 1);
                this.endDate = newEndDate;
                this.toDate = new NgbDate(
                    newEndDate.getFullYear(),
                    newEndDate.getMonth() + 1,
                    newEndDate.getDate(),
                );
                this.reservation.current.endDate = fromJSDateToInputDate(
                    this.endDate,
                );
            }

            this.reservation.current.startHour = null;
            this.reservation.startHours = [];

            this.checkeLocationDates();
        }
    }

    public onFromHourChange(): void {
        if (
            this.reservation.current.startHour &&
            !this.reservation.current.endDate &&
            this.datetimeOpened
        ) {
            this.inputEndDate.openCalendar();
        }
    }

    public onToDateChange(date: NgbDate | null): void {
        this.wasDisabled = this.inputStartHour?.getSelectComponent()?.disabled;
        if (this.inputStartHour?.getSelectComponent()) {
            this.inputStartHour.getSelectComponent().setDisabledState(true);
        }
        this.toDate = date;
        if (date) {
            this.endDate = new Date(date.year, date.month - 1, date.day);

            this.reservation.current.endDate = fromJSDateToInputDate(
                this.endDate,
            );

            this.reservation.current.endHour = null;

            this.fetchSchedulesEnd();
        }
    }

    private fetchSchedulesEnd(): void {
        this.loadingEndHours = true;

        const branch = _.find(
            this.reservation.locations,
            (item) => item.id === _.first(this.reservation.current.location),
        );
        const typeReservation = branch.location === 'INT' ? 'INT' : 'NAT';

        this.findSchedulesUseCase
            .execute({
                id: _.first(this.reservation.current.location) as string,
                idReturn: this.reservation.showDifferenteLocation
                    ? _.first(this.reservation.current.differentLocation)
                    : _.first(this.reservation.current.location),
                location: typeReservation,
                pickup: `${fromJSDateToISODate(this.startDate as Date)}T${DateTime.now().toFormat('HH:mm:ss')}`,
                return: `${fromJSDateToISODate(this.endDate as Date)}T${DateTime.now().toFormat('HH:mm:ss')}`,
            })
            .pipe(
                catchError((error) => {
                    this.loadingEndHours = false;
                    this.reservation.current.endHour = null;
                    this.reservation.endHours = [];
                    setTimeout(() => {
                        if (this.inputStartHour?.getSelectComponent()) {
                            this.inputStartHour
                                .getSelectComponent()
                                .setDisabledState(this.wasDisabled);
                        }
                    }, 0);
                    this.alert
                        .open({
                            title: this.alert.getErrorTitle(error),
                            subtitle: this.alert.getErrorMessage(error),
                            showCancel: false,
                        })
                        .subscribe();
                    return throwError(() => error);
                }),
            )
            .subscribe((schedulesResponse) => {
                this.loadingEndHours = false;

                this.reservation.endHours = _.get(
                    schedulesResponse,
                    'data.schedules.return',
                    [],
                );

                this.store.dispatch(
                    saveEndHours({ value: this.reservation.endHours }),
                );
                this.autoSelectEndHour();

                setTimeout(() => {
                    if (this.inputStartHour?.getSelectComponent()) {
                        this.inputStartHour
                            .getSelectComponent()
                            .setDisabledState(this.wasDisabled === true);
                    }
                    if (
                        this.reservation.endHours.length > 0 &&
                        this.inputEndHour &&
                        !this.reservation.current.endHour
                    ) {
                        this.inputEndHour.focus();
                    }
                }, 100);
            });
    }

    // este metodo tambien lo traje para aca y ya
    public isSelectingChange(isSelecting: boolean): void {
        this.isSelecting = isSelecting;
    }

    public onSearchLocations(term: string): void {
        this.loadingLocations = true;
        this.findLocationsUseCase
            .execute({ searchTerm: term })
            .subscribe((locations) => {
                this.loadingLocations = false;
                this.reservation.locations = locations.data as {
                    [key: string]: unknown;
                }[];
            });
    }

    public onSearchDifferentLocations(term: string): void {
        this.loadingDifferentLocations = true;
        const locationId = _.first(this.reservation.current.location);
        this.findLocationsUseCase
            .execute({
                searchTerm: term,
                isPickupInternational: _.some(
                    this.reservation.locations,
                    (item: Location) =>
                        item.id === locationId && item.location === 'INT',
                ),
                isReturn: true,
                pickupLocationId: locationId,
            })
            .subscribe((locations) => {
                this.loadingDifferentLocations = false;
                this.reservation.differentLocations = locations.data as {
                    [key: string]: unknown;
                }[];
            });
    }

    public onClickBtnAfter(event: any): void {
        this.reservation.showDifferenteLocation =
            !this.reservation.showDifferenteLocation;
        this.toggleSelectLocations();
    }

    protected toggleSelectLocations(): void {
        if (this.reservation.showDifferenteLocation) {
            setTimeout(() => {
                this.inputDifferentLocationProgressBar
                    .getSelectComponent()
                    .open();
            });
            return;
        }
        this.reservation.current.differentLocation = null;
        this.reservation.differentLocations = [];
    }

    public onClickVehicle(): void {
        if (this.status === 'extras' || this.status === 'total') {
            this.router.navigateByUrl(
                this.url.format('reservations/cars-and-categories'),
            );
            return;
        }
    }

    public onClickExtras(): void {
        if (this.status === 'total') {
            this.router.navigateByUrl(
                this.url.format('reservations/trip-enhancements'),
            );
            return;
        }
    }

    public onClickDatetime(): void {
        if (this.status === 'extras' || this.status === 'total') {
            this.router.navigateByUrl(
                this.url.format('reservations/cars-and-categories'),
            );
            return;
        }

        const wasOpen = this.datetimeOpened;
        if (this.datetimeOpened || this.locationOpened) {
            this.close(true);
        }
        this.datetimeOpened = !wasOpen;
        if (this.datetimeOpened) {
            this.datetimeSelected = true;
        }
        this.locactionSelected = false;
    }

    public onClickLocation(): void {
        if (this.status === 'extras' || this.status === 'total') {
            this.router.navigateByUrl(
                this.url.format('reservations/cars-and-categories'),
            );
            return;
        }

        const wasOpen = this.locationOpened;
        if (this.datetimeOpened || this.locationOpened) {
            this.close(true);
        }
        this.locationOpened = !wasOpen;
        if (this.locationOpened) {
            this.locactionSelected = true;
        }
        this.datetimeSelected = false;
    }

    public onClickOverlap(): void {
        this.close(true);
    }

    public onClickUpdateDatetime(): void {
        this.formDatetime.markAllAsTouched();
        if (!this.formDatetime.valid) {
            return;
        }

        const locationInfo: BranchParams = {
            id_sucursal_renta: _.first(this.reservation.current.location),
            id_sucursal_devolucion: _.first(
                this.reservation.current.differentLocation,
            ),
            fRenta: this.reservation.current.startDate,
            hRenta: this.reservation.current.startHour,
            fDevolucion: this.reservation.current.endDate,
            hDevolucion: this.reservation.current.endHour,
            cupon: this.reservation.current.discountCode,
        };

        const branch = _.find(
            this.reservation.locations,
            (item) => item.id === _.first(this.reservation.current.location),
        );

        const locationInt: BranchIntParams = {
            id: _.first(this.reservation.current.location),
            returnBranchId: _.first(this.reservation.current.differentLocation),
            location: branch.location,
            fRenta: this.reservation.current.startDate,
            hRenta: this.reservation.current.startHour,
            fDevolucion: this.reservation.current.endDate,
            hDevolucion: this.reservation.current.endHour,
            type: branch.group,
        };

        if (isValid(this.reservation.current.age)) {
            locationInt.age = this.reservation.current.age as unknown as string;
        }

        this.loadingUpdate = true;

        if (this.reservation.current.origin === 'INT') {
            this.getAvailabilityInternational
                .execute(locationInt)
                .pipe(
                    catchError((error) => {
                        this.loadingUpdate = false;
                        this.alert.openDefault(error);
                        return throwError(() => error);
                    }),
                )
                .subscribe((locations) => {
                    this.onUpdateHour(locations);
                    this.loadingUpdate = false;
                    this.close(true);
                });
        } else {
            this.findbranchesUseCase
                .execute(locationInfo)
                .pipe(
                    catchError((error) => {
                        this.loadingUpdate = false;
                        this.alert.openDefault(error);
                        return throwError(() => error);
                    }),
                )
                .subscribe((locations) => {
                    this.onUpdateHour(locations);
                    this.loadingUpdate = false;
                    this.close(true);
                });
        }
    }

    private onUpdateHour(locations: any): void {
        this.updateReservationUseCase
            .execute({
                startDate: this.reservation.startDatetime,
                endDate: this.reservation.endDatetime,
                startHour: this.reservation.current.startHour,
                endHour: this.reservation.current.endHour,
            })
            .subscribe();
        if (locations.action === 'CONTINUE_SELECT_BRANCHS') {
            //TODO
        } else {
            this.store.dispatch(saveVehicles({ value: locations.data }));
            this.store.dispatch(
                saveStartHours({
                    value: this.reservation.startHours,
                }),
            );
            this.store.dispatch(
                saveEndHours({ value: this.reservation.endHours }),
            );
        }
    }

    private saveLocations(): void {
        this.store.dispatch(
            saveLocations({ value: this.reservation.locations }),
        );
    }

    private saveDifferentLocations(): void {
        this.store.dispatch(
            saveDifferentLocations({
                value: this.reservation.differentLocations,
            }),
        );
    }

    private syncReservationScheduleHours(schedulesResponse: any): void {
        const scheduleHours = getScheduleHours(schedulesResponse);

        this.reservation.startHours = scheduleHours.pickup;
        this.reservation.endHours = scheduleHours.return;
        this.store.dispatch(
            saveStartHours({ value: this.reservation.startHours }),
        );
        this.store.dispatch(saveEndHours({ value: this.reservation.endHours }));
    }

    private handleUnavailableReservationHour(
        type: 'pickup' | 'return',
        availableHours: string[],
    ): boolean {
        const validation = validateScheduleHourAvailability(
            type === 'pickup'
                ? this.reservation.current.startHour
                : this.reservation.current.endHour,
            availableHours,
        );

        if (validation.isAvailable) {
            return false;
        }

        if (validation.scheduleWindow) {
            this.alert
                .openScheduleUnavailable(
                    type,
                    validation.scheduleWindow.openHour,
                    validation.scheduleWindow.closeHour,
                )
                .subscribe();
            return true;
        }

        this.openNoScheduleAvailabilityAlert();
        return true;
    }

    private openNoScheduleAvailabilityAlert(): void {
        this.alert
            .open({
                title: this.alert.getErrorTitle({
                    error: {
                        code: 'NO_SCHEDULE_AVAILABILITY',
                    },
                }),
                subtitle: this.alert.getErrorMessage({
                    error: {
                        code: 'NO_SCHEDULE_AVAILABILITY',
                    },
                }),
                showCancel: false,
            })
            .subscribe();
    }

    private validateReservationHoursForLocationChange(
        branch: any,
    ): Observable<boolean> {
        if (branch.location === 'INT' && branch.group === 'city') {
            return of(true);
        }

        const typeReservation = branch.location === 'INT' ? 'INT' : 'NAT';

        return this.findSchedulesUseCase
            .execute({
                id: _.first(this.reservation.current.location) as string,
                idReturn: resolveReturnBranchId(
                    this.reservation.showDifferenteLocation,
                    this.reservation.current.location,
                    this.reservation.current.differentLocation,
                ),
                location: typeReservation,
                pickup: `${fromJSDateToISODate(this.startDate as Date)}T${DateTime.now().toFormat('HH:mm:ss')}`,
                return: `${fromJSDateToISODate(this.endDate as Date)}T${DateTime.now().toFormat('HH:mm:ss')}`,
            })
            .pipe(
                switchMap((schedulesResponse) => {
                    this.syncReservationScheduleHours(schedulesResponse);

                    if (
                        this.handleUnavailableReservationHour(
                            'pickup',
                            this.reservation.startHours,
                        )
                    ) {
                        return of(false);
                    }

                    if (
                        this.handleUnavailableReservationHour(
                            'return',
                            this.reservation.endHours,
                        )
                    ) {
                        return of(false);
                    }

                    return of(true);
                }),
                catchError((error) => {
                    this.alert.openDefault(error).subscribe();
                    return of(false);
                }),
            );
    }

    public onClickUpdateLocation(): void {
        this.formLocations.markAllAsTouched();

        if (!this.reservation.showDifferenteLocation) {
            this.formLocations.patchValue(
                {
                    differentLocation: '',
                },
                { emitEvent: false },
            );
            this.formLocations.get('differentLocation')?.setErrors(null);
            this.formLocations.updateValueAndValidity();
        }
        if (!this.formLocations.valid) {
            return;
        }

        this.loadingUpdate = true;

        const branch = _.find(
            this.reservation.locations,
            (item) => item.id === _.first(this.reservation.current.location),
        );

        const locationInfo: BranchParams = {
            id_sucursal_renta: _.first(this.reservation.current.location),
            id_sucursal_devolucion: _.first(
                this.reservation.current.differentLocation,
            ),
            fRenta: this.reservation.current.startDate,
            hRenta: this.reservation.current.startHour,
            fDevolucion: this.reservation.current.endDate,
            hDevolucion: this.reservation.current.endHour,
            cupon: this.reservation.current.discountCode,
        };

        const locationInt: BranchIntParams = {
            id: _.first(this.reservation.current.location),
            returnBranchId: _.first(this.reservation.current.differentLocation),
            location: branch.location,
            fRenta: this.reservation.current.startDate,
            hRenta: this.reservation.current.startHour,
            fDevolucion: this.reservation.current.endDate,
            hDevolucion: this.reservation.current.endHour,
            type: branch.group || branch.type,
        };

        const branchIntParams: BranchIntParams = {
            id: _.first(this.reservation.current.location),
            returnBranchId: _.first(this.reservation.current.differentLocation),
            location: branch.location,
            lat: branch.gps.latitude,
            lon: branch.gps.longitude,
            fRenta: this.reservation.current.startDate,
            hRenta: this.reservation.current.startHour,
            fDevolucion: this.reservation.current.endDate,
            hDevolucion: this.reservation.current.endHour,
            type: branch.group || branch.type,
        };

        if (isValid(this.reservation.current.age)) {
            locationInt.age = this.reservation.current.age as unknown as string;
        }

        this.validateReservationHoursForLocationChange(branch).subscribe(
            (isReservationHoursValid) => {
                if (!isReservationHoursValid) {
                    this.loadingUpdate = false;
                    return;
                }

                if (branch.location === 'INT') {
                    this.reservation.current.origin = 'INT';
                    if (branch.group === 'city') {
                        this.loadingUpdate = false;
                        this.store.dispatch(
                            saveLocationInt({
                                value: branchIntParams,
                            }),
                        );
                        this.updateReservationUseCase
                            .execute({
                                cityInternational: branch,
                            })
                            .subscribe();
                        this.router.navigate([
                            this.url.format(
                                'international-reservations/branch-search',
                            ),
                        ]);
                        return;
                    } else {
                        this.getAvailabilityInternational
                            .execute(locationInt)
                            .pipe(
                                catchError((error) => {
                                    this.loadingUpdate = false;
                                    this.alert.openDefault(error);
                                    return throwError(() => error);
                                }),
                            )
                            .subscribe((locations: any) => {
                                this.loadingUpdate = false;
                                this.updateReservation();
                                this.saveLocations();
                                this.saveDifferentLocations();
                                this.store.dispatch(
                                    saveVehicles({ value: locations.data }),
                                );
                                this.restoreReservationUseCase
                                    .execute()
                                    .subscribe();
                                this.close();
                                return of();
                            });
                        return;
                    }
                } else {
                    this.reservation.current.origin = 'NAT';
                    this.findbranchesUseCase
                        .execute(locationInfo)
                        .pipe(
                            catchError((error) => {
                                this.loadingUpdate = false;
                                this.alert.openDefault(error);
                                return throwError(() => error);
                            }),
                        )
                        .subscribe((locations) => {
                            this.loadingUpdate = false;
                            this.saveLocations();
                            this.saveDifferentLocations();
                            this.updateReservation();
                            this.store.dispatch(
                                saveVehicles({ value: locations.data }),
                            );
                            this.restoreReservationUseCase
                                .execute()
                                .subscribe();
                            this.close();
                        });
                }
            },
        );
    }

    private updateReservation(): void {
        this.updateReservationUseCase
            .execute({
                location: _.find(
                    this.reservation.locations,
                    (item: any) =>
                        item.id === _.first(this.reservation.current.location),
                ),
                locationSelected: _.first(this.reservation.current.location),
                differentLocation:
                    _.find(
                        this.reservation.differentLocations,
                        (item: any) =>
                            item.id ===
                            _.first(this.reservation.current.differentLocation),
                    ) || null,
                differentLocationSelected:
                    _.first(this.reservation.current.differentLocation) || null,
                origin: this.reservation.current.origin,
            })
            .subscribe();
    }

    public stop(): void {
        //TODO
        this.formLocations.setValidators(null);
    }
}
